import http from './helpers/httpInterceptor'

const state = () => ({
  workTypeList: [],
  editWorkType: {},
  deleteWorkType: {},
  addNewWorkType: {},
  payrollPeriodList: [],
  projectList: [],
  detailProject: {}
  // editPayrollPeriod: {},
  // deletePayrollPeriod: {},
  // addNewPayrollPeriod: {},
});

// mutations
const mutations = {
  GET_WORK_TYPE_LIST(states, data) {
    states.workTypeList = data;
  },
  GET_PAYROLL_PERIOD_LIST(states, data) {
    states.payrollPeriodList = data;
  },
  GET_PROJECT_LIST(states, data) {
    states.projectList = data;
  },
  GET_DETAIL_TO_PROJECT(states, data) {
    states.detailProject = data;
  },
};

// actions
const actions = {
  getWorkTypeList({ commit }, url) {
    return http.get(`/tms/settings/get-work-types${url}`).then(res => {
      commit('GET_WORK_TYPE_LIST', res.data);
      return res.data;
    }).catch(error => {
      throw (error)
    })
  },
  addNewWorkType({ commit }, payload) {
    return http.post(`/tms/settings/create`, payload).then(res => {
      commit('ADD_NEW_WORK_TYPE', res.data);
      return res.data;
    }).catch(error => {
      throw (error)
    })
  },
  getPayrollPeriodList({ commit }, url) {
    return http.get(`/tms/settings/work-periods${url}`).then(res => {
      commit('GET_PAYROLL_PERIOD_LIST', res.data);
      return res.data;
    }).catch(error => {
      throw (error)
    })
  },
  getProjectSettingList({ commit }, url) {
    return http.get(`/tms/settings/project${url}`).then(res => {
      commit('GET_PROJECT_LIST', res.data);
      return res.data;
    }).catch(error => {
      throw (error)
    })
  },
  deleteProject(_, id) {
    return http
      .delete("/tms/settings/project/" + id)
      .then((res) => {
          return res.data;
      })
      .catch((error) => {
          throw (error)
      });
  },
  addProject(_, payload) {
    return http
        .post("tms/settings/project/create", payload)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            throw (error)
        });
  },

  editProject(_, payload) {
    return http
        .put(`/tms/settings/project/edit/${payload.id}` , payload)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            throw (error)
        });
  },
  addMemberToProject(_, payload) {
    return http
        .post("tms/settings/project/add-member", payload)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            throw (error)
        });
  },
  deleteMemberToProject(_, url) {
    return http
        .put("tms/settings/project/remove-member" + url)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            throw (error)
        });
  },
  getListDetailProject({commit}, id) {
    return http
        .get("tms/settings/project/" + id)
        .then((res) => {
          commit('GET_DETAIL_TO_PROJECT', res.data);
            return res.data;
        })
        .catch((error) => {
            throw (error)
        });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
